import React from 'react';
import { ColumnResizeContext, ColumnResizeContextValue } from './ColumnResize';

export interface ColumnResizeConsumerProps {
  children: (context: ColumnResizeContextValue) => React.ReactNode;
}

export const ColumnResizeConsumer: React.FC<ColumnResizeConsumerProps> = ({
  children,
}) => {
  return (
    <ColumnResizeContext.Consumer>
      {context => {
        return children(context);
      }}
    </ColumnResizeContext.Consumer>
  );
};
